import React from 'react';
import WorkflowLandingPage from '../components/WorkflowLandingPage';
import { JobType } from '../graphql/types';

/**
 * BorrowerAnalysisLandingPage - Wrapper component for Borrower Analysis workflow
 * 
 * Renders the shared WorkflowLandingPage with JobType.BA to display
 * and manage Borrower Analysis jobs.
 * 
 * Requirements: 4.1, 14.1
 */
const BorrowerAnalysisLandingPage: React.FC = () => {
  return <WorkflowLandingPage jobType={JobType.BA} />;
};

export default BorrowerAnalysisLandingPage;
